// hooks/api/notification.queries.ts
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as notificationService from "@/services/notification.service";
import { notifySuccess } from "@/lib/notification";

export const notificationKeys = {
  all: ["notifications"] as const,
};

export const useNotificationsQuery = () =>
  useQuery({
    queryKey: notificationKeys.all,
    queryFn: () => notificationService.fetchNotifications(),
  });

export const useMarkAllAsReadMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificationService.markAllAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      notifySuccess("All notifications marked as read");
    },
  });
};
